import { IconWrapper } from '../runtime';
export default IconWrapper('light-mode', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M8 0.999756V1.99976M8 13.9998V14.9998M14 7.99976H15M1 7.99976H2M3 2.99976L3.70711 3.70686M13 2.99976L12.2929 3.70686M3.75 12.2498L3.04289 12.9569M12.25 12.2498L12.9571 12.9569M11.625 7.99979C11.625 10.0018 10.002 11.6248 8 11.6248C5.99797 11.6248 4.375 10.0018 4.375 7.99979C4.375 5.99775 5.99797 4.37479 8 4.37479C10.002 4.37479 11.625 5.99775 11.625 7.99979Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});